module.exports = __webpack_public_path__ + "static/media/empty.cd471aca.svg";